<template>
  <div class="wrap_xszn">
    <v-tabs :menus="menus"></v-tabs>
    <div class="czzn-main">
      <router-view/>
    </div><!--xszn_main-->
  </div>
</template>
<script>
import vTabs from '../../components/tabs.vue';

export default {
  name: 'czzn',
  components: {
    vTabs,
  },
  data() {
    return {
      menus: [
        { name: '产品介绍', path: '/czzn/cpjs', className: 'czzn-tbs-cpjs' },
        { name: '账套管理', path: '/czzn/ztgl', className: 'czzn-tbs-ztgl' },
        { name: '初始设置', path: '/czzn/cssz', className: 'czzn-tbs-cssz' },
        { name: '发票管理', path: '/czzn/fpgl', className: 'czzn-tbs-fpgl' },
        { name: '凭证处理', path: '/czzn/pzcl', className: 'czzn-tbs-pzcl' },
        { name: '账表查询', path: '/czzn/zbcx', className: 'czzn-tbs-zbcx' },
        { name: '财务报表', path: '/czzn/cwbb', className: 'czzn-tbs-cwbb' },
        { name: '期末处理', path: '/czzn/qmcl', className: 'czzn-tbs-qmcl' },
        { name: '纳税申报', path: '/czzn/nssb', className: 'czzn-tbs-nssb' },
        { name: '会员专享', path: '/czzn/hyzx', className: 'czzn-tbs-hyzx' },
      ],
    };
  },
};
</script>
